import React, { useState } from "react";
import DatePicker from "./DatePicker";
import Switch from "./Switch";

const ToggleDatePicker = ({
  postNowLabel = "Post Now",   // Default value for the "Post Now" label
  postLaterLabel = "Post Later", // Default value for the "Post Later" label
  dateLabel = "Select Post Date",
  dateDescription = "Choose when to schedule the post.",
  later = false,
  selectedDate = null,
  setSelectedDate = () => {} // Default no-op function
}) => {
  const [postLater, setPostLater] = useState(later); // Determines if "Post Later" is selected

  // Handle toggle change
  const handleToggleChange = (evt) => {
    evt.preventDefault();
    setPostLater(!postLater);
    setSelectedDate(null); // Reset the date when switching modes
  };

  return (
    <div>
      {/* Switch Component */}
      <Switch
        isOn={postLater}
        handleToggle={handleToggleChange}
        onLabel={postLaterLabel}
        offLabel={postNowLabel}
      />

      {postLater && (
        <div className="mt-4">
          <DatePicker
            label={dateLabel}
            description={dateDescription}
            selectedDate={selectedDate}
            onChange={setSelectedDate}
          />
        </div>
      )}
    </div>
  );
};

export default ToggleDatePicker;
